module.exports = __webpack_public_path__ + "static/scale-model-of-seminole-hard-rock-hotel-&-casino-in-davie-florida-1fc9c0a18345a88d2b79468d39d4ee10.png";